<template>
  <div>
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:WarehouseIds>
        <el-select
          multiple
          v-model="filters.WarehouseIds"
          filterable
          placeholder="请选择"
          @change="WarehouseChange"
        >
          <el-option
            v-for="item in warehouselist"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:OrgIDs>
        <el-select
          multiple
          v-model="filters.OrgIDs"
          filterable
          placeholder="请选择"
        >
         <el-option
              v-for="item in customerList"
              :label="item.customName"
              :value="item.id"
              :key="item.id"
            ></el-option>
        </el-select>
      </template>
      <template v-slot:feeItemIDs>
        <el-select
          multiple
          v-model="filters.feeItemIDs"
          filterable
          placeholder="请选择"
       
        >
          <el-option
            v-for="item in feeItemList"
            :label="item.feeItemName"
            :value="item.feeItemID"
            :key="item.feeItemID"
          ></el-option>
        </el-select>
      </template>
     

 <template v-slot:SettlementDate>
        <el-date-picker
          v-model="filters.SettlementDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>


      <template slot-scope="scope" slot="feeFlowSumNo">
        <el-link
          :underline="false"
          type="primary"
          @click.native="showFeeFlowDetail(scope.row)"
          >{{ scope.row.feeFlowSumNo }}
        </el-link>
      </template>

     
    </TwTable>

   <!-- 费用项明细 -->
     <LogDialog
      :logConfig="FeeFlowDetailTableConfig"
      :showLog="showLogFeeDetail"
      :requestData="{list:[{
        OrgID:currentRow.orgID,
        Department:currentRow.department,
        WareHouseID:currentRow.wareHouseID,
        FeeTypeID:currentRow.feeTypeID,
        FeeItemID:currentRow.feeItemID,
        SettlementDate:currentRow.settlementDate,
        Currency:currentRow.currency
        }]}"
      :requestApi="'/CostReport/GetFeeFlowDetailList'"
      :requestMethod="'post'"
      v-if="showLogFeeDetail"
      @showDialog="showDialogFeeDetail"
    ></LogDialog>


    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{
        businessType: 30,
        businessCode: currentRow.feeItemID,
      }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>
  </div>
</template>

<script>
import {
  GetFeeFlowSumList,FeeFlowSumExport,FeeFlowDetailExport
} from "@/api/costManagement/feeFlowSumReport.js";
import {
  getCustomerList
} from "@/api/common/common.js";
import {
  getFeeItemBatchBasis
} from "@/api/costManagement/expenseSetting.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import axios from "axios";
import { thereAre, arrToJoin, toSelectOptions  } from "util/util";
import LogDialog from "../../components/TwTable/components/logDialog";
export default {
  components: { LogDialog, TwTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      tableConfig: {
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: false, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          options: [
            {
              name: "日志",
              size: "small",
              type: "text",
              event: "getbusinessLoglist", // 操作的事件名
            },
          ],
        },
        column: [
          // 表格列配置
          {
            prop: "feeFlowSumNo",
            label: "单据号",
            align: "center",
            sortable: true,
            minWidth: "130",
            slot: true,
          },
          {
            prop: "customName",
            label: "客户",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "department",
            label: "部门",
            align: "center",
            sortable: true,
            minWidth: "180",
          },
          {
            prop: "warehouseName",
            label: "仓库",
            minWidth: "150",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "feeTypeName",
            label: "费用类型",
            align: "center",
            sortable: true,
            minWidth: "100",
          },

          {
            prop: "feeItemName",
            label: "费用项",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "settlementDateDesc",
            label: "结算日期",
            align: "center",
            minWidth: "100",
            sortable: true,
          },

          {
            prop: "volume",
            label: "体积",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "quantity",
            label: "数量",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "amount",
            label: "金额",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
           {
            prop: "currency",
            label: "币别",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
           {
            prop: "percentageDesc",
            label: "占比",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
        ],
      },
      showLogFeeDetail:false,
     
      feeItemdata: [],
      FeeTypeList: [],
      selectFeeTypeList: [],
      addForm: [{ WarehouseId: 0, FeeTypeID: 0, CheckBoxList: [] }],
      disableFeeTypeID: true,
      diablefeeItem: true,
      warehouselist: [],
      customerList: [],
      startStausList: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: 0,
          label: "禁用",
        },
      ],
      addfeeItemVisible: false,
      WareHouse: [], //仓库
      searchData: {
        //搜索列配置

        search: [
       
          {
            type: "select",
            key: "WarehouseIds",
            prop: "WarehouseIds",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择仓库",
            option: this.warehouselist,
          },
          {
            type: "select",
            key: "OrgIDs",
            prop: "OrgIDs",
            label: "客户",
            multiple: true,
            slot: true,
            placeholder: "请选择客户",
            option: this.customerList,
          },
         
           {
            key: "SettlementDate",
            prop: "SettlementDate",
            slot: true,
            label: "结算日期",
          },
          {
            type: "select",
            key: "feeItemIDs",
            prop: "feeItemIDs",
            label: "费用项",
            multiple: true,
            slot: true,
            placeholder: "请选择费用项",
            option: this.feeItemList,
          },

          {
            type: "input",
            key: "Department",
            label: "部门",
            placeholder: "请输入部门",
            clearable: true,
          },
        ],
        ///高级搜索配置
        moreSearch: [
       
        
        ],
        
      },
      buttonList: [],
      feeItemList:[],
      feeFlowDetailiframe:"",
      feeFlowDetaildialogVisible:false,
       FeeFlowDetailTableConfig: {
        title: "费用明细",
        width:'96%',
        loading: true, // 显示loading状态
        showPage: true,
        column: [
           // 表格列配置
          {
            prop: "settlementDateDesc",
            label: "时间",
            align: "center",
            sortable: true,
            minWidth: "80",
          },

          {
            prop: "department",
            label: "部门",
            align: "center",
            sortable: true,
          },
          {
            prop: "groupName",
            label: "组名",
            align: "center",
            sortable: true,
            minWidth: "140",
          },
          {
            prop: "skuCode",
            label: "SKU代码",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "skuName",
            label: "Sku名称",
            align: "center",
            sortable: true,
            minWidth: "160",
          },
          {
            prop: "wareHouseName",
            label: "仓库名称",
            align: "center",
            minWidth: "120",
            sortable: true,
          },
          {
            prop: "quantity",
            label: "数量",
            align: "center",
            minWidth: "80",
            sortable: true,
           
          },

          {
            prop: "stockAge",
            label: "库龄",
            align: "center",
            sortable: true,
          },
          {
            prop: "volume",
            label: "SKU体积",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
           {
            prop: "amount",
            label: "金额",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
           {
            prop: "currency",
            label: "币别",
            align: "center",
            sortable: true,
            minWidth: "80",
          },
           {
            prop: "feeFlowStatusDesc",
            label: "计算状态",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "feeCalContent",
            label: "备注",
            align: "center",
            sortable: true,
             minWidth: "120",
            
          },
        ],
      },

      //-------------
    };
  },
  methods: {
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },


  // 日志关闭事件
        showDialogFeeDetail() {
            this.showLogFeeDetail = !this.showLogFeeDetail
        },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },
    enableItem() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      UpdateFeeItemStatus({ feeItemID: row[0].feeItemID, IsStart: 1 }).then(
        (res) => {
          if (res.success) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.initTable();
          } else {
            this.$message({
              message: "操作失败",
              type: "error",
            });
          }
        }
      );
    },
    disableItem() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      UpdateFeeItemStatus({ feeItemID: row[0].feeItemID, IsStart: 0 }).then(
        (res) => {
          if (res.success) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.initTable();
          } else {
            this.$message({
              message: "操作失败",
              type: "error",
            });
          }
        }
      );
    },
    edidFeeItem() {
      this.addfeeItemVisible = true;
    },

    WarehouseChange() {
      let para = {
        WarehouseIds: thereAre(this.filters.WarehouseIds),
        FeeTypeNames: thereAre(this.filters.FeeTypeNames),
        FeeItemNames: thereAre(this.filters.FeeItemNames),
        StartStaus: thereAre(this.filters.StartStaus),
      };
      GetFeeTypeList(para).then((res) => {
        this.feeTypeList = res.response;
      });
    },
    FeeTypeNameChange() {
      let para = {
        WarehouseIds: thereAre(this.filters.WarehouseIds),
        FeeTypeNames: thereAre(this.filters.FeeTypeNames),
        FeeItemNames: thereAre(this.filters.FeeItemNames),
        StartStaus: thereAre(this.filters.StartStaus),
      };
      GetFeeItemList(para).then((res) => {
        this.feeItemList = res.response;
      });
    },
    //查询列表
    initTable() {
      const { WarehouseIds, OrgIDs, Department, SettlementDate, feeItemIDs} =
        this.newfilters;
        console.log(this.newfilters)
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        WarehouseIds: thereAre(WarehouseIds),
        OrgIDs: thereAre(OrgIDs),
        Department: Department,
        feeItemIDs: thereAre(feeItemIDs),
      
      };
       if (SettlementDate != null && SettlementDate != "null") {
        para.startdate = SettlementDate[0];
        para.enddate = SettlementDate[1];
      }

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      GetFeeFlowSumList(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;

      let CheckIds = "";
      row.forEach((item) => {
        CheckIds += item.feeFlowSumID + ",";
      });
     
      if(CheckIds!=""){
         CheckIds=CheckIds.substring(0,CheckIds.length-1);
      }
     const { WarehouseIds, OrgIDs, Department, SettlementDate, feeItemIDs } =
        this.newfilters;
      let pata = {
        page: 1,
        pageSize: 60001,
        WarehouseIds: thereAre(WarehouseIds),
        OrgIDs: thereAre(OrgIDs),
        Department: Department,
        CheckIds:CheckIds,
        feeItemIDs: thereAre(feeItemIDs),
        
      };

 if (SettlementDate != null && SettlementDate != "null") {
        pata.startdate = SettlementDate[0];
        pata.enddate = SettlementDate[1];
      }
      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: FeeFlowSumExport,
        method: "post",
        data: pata,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    onSubmit() {
      FeeItemSubmit(this.addForm).then((res) => {
        if (res.success) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.addfeeItemVisible = false;
          this.initTable();
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },


    //导出
    handleDetailExport() {
      let row = this.selectRows.rows;

      let selectArray=[];
      row.forEach((item) => {
       selectArray.push({
        OrgID:item.orgID,
        Department:item.department,
        WareHouseID:item.wareHouseID,
        FeeTypeID:item.feeTypeID,
        FeeItemID:item.feeItemID,
        SettlementDate:item.settlementDate,
        Currency:item.currency});
      });

     const { WarehouseIds, OrgIDs, Department, SettlementDate, feeItemIDs } =
        this.newfilters;
      let pata = {
        page: 1,
        pageSize: 60001,
        list: selectArray,
        WarehouseIds: thereAre(WarehouseIds),
        OrgIDs: thereAre(OrgIDs),
        Department: Department,
        feeItemIDs: arrToJoin(feeItemIDs),
     
      };
     if (SettlementDate != null && SettlementDate != "null") {
        pata.startdate = SettlementDate[0];
        pata.enddate = SettlementDate[1];
      }
      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: FeeFlowDetailExport,
        method: "post",
        data: pata,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },


    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    initDropList() {
      getCustomerList({}).then((res) => {
        this.customerList = res.data.response;
      });

      
      getFeeItemBatchBasis({}).then((res) => {
        this.feeItemList=res.data.response.feeItemList
       
      });
    },

    showFeeFlowDetail(rows){
       this.currentRow = rows;
       this.showLogFeeDetail = true;
  
    }
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
    let user = JSON.parse(window.localStorage.user);

    this.warehouselist = user.warehouseList;

    this.initDropList();
  },
};
</script>
<style scoped lang="less">
</style>